import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=5d7052a9&scoped=true&"
import script from "./OrderTracking.vue?vue&type=script&lang=js&"
export * from "./OrderTracking.vue?vue&type=script&lang=js&"
import style0 from "./OrderTracking.vue?vue&type=style&index=0&id=5d7052a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7052a9",
  null
  
)

export default component.exports